import {
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface UpdateAccountManagerParams {
  workplaceId: string;
  userId: string;
}

export function useUpdateAccountManager(
  options: UseMutationOptions<WorkplaceProfileResponse, unknown, UpdateAccountManagerParams> = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, userId }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: {
              accountManagerId: userId,
            },
          },
        },
        requestSchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
